import React, {useState, useEffect} from 'react';

import {differenceBy, isEqual} from 'lodash';
import DualSelectBoxContainer from 'components/DualSelect/DualSelectBoxContainer';
import {sortObjects} from 'Helpers/sortObjects';
import {filterByValue} from 'Helpers/filterByValue';
import SpinnerButton from 'components/SpinnerButton';
import './style.scss';

const DualSelect = (props) => {
    const {selectedList, fullList, onSelect, contentType, showAssignAll, hideGroups, largeBoxes} = props;
    const [unassignedItems, setUnassignedItems] = useState([]);
    const [assignedItems, setAssignedItems] = useState([]);
    const [selectedUnassignedItems, setSelectedUnassignedItems] = useState([]);
    const [selectedAssignedItems, setSelectedAssignedItems] = useState([]);
    const [filteredUnassignedItems, setFilteredUnassignedItems] = useState([]);
    const [filteredAssignedItems, setFilteredAssignedItems] = useState([]);
    const [assignedSearchValue, setAssignedSearchValue] = useState('');
    const [assignedSortDirection, setAssignedSortDirection] = useState('asc');

    const [unassignedSearchValue, setUnassignedSearchValue] = useState('');
    const [unassignedSortDirection, setUnassignedSortDirection] = useState('asc');
    const [unassignedViewType, setUnassignedViewType] = useState('all');
    // const [confirmModalOpen, setConfirmModalOpen] = useState(false);



    useEffect(() => {
        let newFullListObjects = fullList.map(item => {
            return {
                id: item.id,
                name: (contentType === 'savedSearches' && item.sourceName) ? item.sourceName : item.title ? item.title : item.name ? item.name : item.email
            }
        })
        let newSelectedListObjects = selectedList.map(item => {
            return {
                id: item.id,
                name: (contentType === 'savedSearches' && item.sourceName) ? item.sourceName : item.title ? item.title : item.name ? item.name : item.email
            }
        })
        const uniqueFullList = differenceBy(newFullListObjects, newSelectedListObjects, 'id');
        let sortedFullList = sortObjects(uniqueFullList, 'name', 'asc');
        let sortedSelectedList = sortObjects(newSelectedListObjects, 'name', 'asc');
        setUnassignedItems(sortedFullList);
        setAssignedItems(sortedSelectedList);
    }, []);

    useEffect(() => {
        let newUnassignedItems = [...unassignedItems];
        let filteredBySearch = filterByValue(newUnassignedItems, 'name', unassignedSearchValue);
        let sortedByDirection = sortObjects(filteredBySearch, 'name', unassignedSortDirection);
        let sortedByView = sortedByDirection.filter(item => {
            if(unassignedViewType === 'all') {
                return item;
            } else if(unassignedViewType === 'items') {
                return !item.hasOwnProperty('group');
            } else {
                return item.hasOwnProperty('group');
            }
        });
        setFilteredUnassignedItems(sortedByView);
    }, [unassignedSearchValue, unassignedSortDirection, unassignedViewType, unassignedItems]);

    useEffect(() => {
        let newAssignedItems = [...assignedItems];
        let filteredBySearch = filterByValue(newAssignedItems, 'name', assignedSearchValue);
        let sortedByDirection = sortObjects(filteredBySearch, 'name', assignedSortDirection);
        setFilteredAssignedItems(sortedByDirection);
    }, [assignedSearchValue, assignedSortDirection, assignedItems]);

    // const toggleConfirmModal = () => setConfirmModalOpen(!confirmModalOpen);

    const handleSearchFilter = (source, searchValue) => {
        if(source === 'unassigned') {
            setUnassignedSearchValue(searchValue);
            let newUnassignedList = unassignedItems.filter(item => {
                return item.name.toLowerCase().includes(searchValue.toLowerCase());
            });
            let sortedList = sortObjects(newUnassignedList, 'name', unassignedSortDirection);
            setFilteredUnassignedItems(sortedList);
        } else {
            setAssignedSearchValue(searchValue);
            let newAssignedList = assignedItems.filter(item => {
                return item.name.toLowerCase().includes(searchValue.toLowerCase());
            });
            let sortedList = sortObjects(newAssignedList, 'name', assignedSortDirection);
            setFilteredAssignedItems(sortedList);
        }
    };

    const handleClearSearch = (source) => {
        handleSearchFilter(source, '');
    };

    const moveLeft = () => {
        let newUnassignedItems = [...unassignedItems];
        let newAssignedItems = [...assignedItems];
        if(selectedAssignedItems.length > 0) {
            selectedAssignedItems.map(item => {
                newUnassignedItems.push(item);
                newAssignedItems.splice(newAssignedItems.indexOf(item), 1);
            });
            setAssignedItems(newAssignedItems);
            setUnassignedItems(newUnassignedItems);
            setFilteredAssignedItems(newAssignedItems);
            setFilteredUnassignedItems(newUnassignedItems);
            setSelectedAssignedItems([]);
            setSelectedUnassignedItems([]);
            onSelect(newAssignedItems);
        }
    };

    const moveRight = () => {
        let newUnassignedItems = [...unassignedItems];
        let newAssignedItems = [...assignedItems];

        if(selectedUnassignedItems.length > 0) {
            selectedUnassignedItems.map(item => {
                if(item.group) {
                    item.items.map(alertInGroup => {
                        let foundAlert = newUnassignedItems.find(i => i.id === alertInGroup.id);
                        if(foundAlert && newAssignedItems.indexOf(foundAlert === -1)) {
                            newAssignedItems.push(foundAlert);
                            newUnassignedItems.splice(newUnassignedItems.indexOf(foundAlert), 1);
                        }
                    });
                } else {

                    let foundItem = newAssignedItems.find(n => n.id === item.id);
                    if(!foundItem) {
                        newAssignedItems.push(item);
                        newUnassignedItems.splice(newUnassignedItems.indexOf(item), 1);
                    }
                }
            });
            setAssignedItems(newAssignedItems);
            setUnassignedItems(newUnassignedItems);
            setSelectedAssignedItems([]);
            setSelectedUnassignedItems([]);
            onSelect(newAssignedItems);
        }
    };

    const moveAllRight = () => {
        // if(showConfirm) {
        //     toggleConfirmModal();
        //     return;
        // }
        let newFilteredItems = [...filteredUnassignedItems];
        let newUnassignedItems = [...unassignedItems];
        let newAssignedItems = [...assignedItems];

        newFilteredItems.map(item => {
            if(item.group) {
                item.items.map(alertInGroup => {
                    let foundAlert = newUnassignedItems.find(i => {
                        return i.id === alertInGroup.id;
                    });
                    if(foundAlert) {
                        if(newAssignedItems.indexOf(foundAlert === -1)) {
                            newAssignedItems.push(foundAlert);
                            newUnassignedItems.splice(newUnassignedItems.indexOf(foundAlert), 1);
                        }
                    }
                });
            } else {
                let foundItem = newAssignedItems.find(n => n.id === item.id);
                if(!foundItem) {
                    newAssignedItems.push(item);
                    newUnassignedItems.splice(newUnassignedItems.indexOf(item), 1);
                }
            }
        });
        setAssignedItems(newAssignedItems);
        setUnassignedItems(newUnassignedItems);
        setSelectedAssignedItems([]);
        setSelectedUnassignedItems([]);
        onSelect(newAssignedItems);
    };

    const moveAllLeft = () => {
        let newFilteredItems = [...filteredAssignedItems];
        let newUnassignedItems = [...unassignedItems];
        let newAssignedItems = [...assignedItems];

        newFilteredItems.map(item => {
            newUnassignedItems.push(item);
            newAssignedItems.splice(newAssignedItems.indexOf(item), 1);
        });

        setAssignedItems(newAssignedItems);
        setUnassignedItems(newUnassignedItems);
        setFilteredAssignedItems(newAssignedItems);
        setFilteredUnassignedItems(newUnassignedItems);
        setSelectedAssignedItems([]);
        setSelectedUnassignedItems([]);
        onSelect(newAssignedItems);
    };

    const handleItemSelect = (item, source) => {
        if(source === 'unassigned') {
            let newSelectedItems = [...selectedUnassignedItems];
            if(newSelectedItems.indexOf(item) > -1) {
                newSelectedItems.splice(newSelectedItems.indexOf(item), 1);
            } else {
                newSelectedItems.push(item);
            }
            setSelectedUnassignedItems(newSelectedItems);
        } else {
            let newSelectedItems = [...selectedAssignedItems];
            if(newSelectedItems.indexOf(item) > -1) {
                newSelectedItems.splice(newSelectedItems.indexOf(item), 1);
            } else {
                newSelectedItems.push(item);
            }
            setSelectedAssignedItems(newSelectedItems);
        }
    };

    return (
        <div className={`dual-select ${largeBoxes ? 'dual-select--large-boxes' : ''}`}>
            <DualSelectBoxContainer
                source="unassigned"
                list={filteredUnassignedItems}
                selected={selectedUnassignedItems}
                handleItemSelect={handleItemSelect}
                handleSearchFilter={handleSearchFilter}
                handleClearSearch={handleClearSearch}
                handleSortDirection={setUnassignedSortDirection}
                sortDirection={unassignedSortDirection}
                searchValue={unassignedSearchValue}
                contentType={contentType}
                handleViewTypeChange={setUnassignedViewType}
                viewType={unassignedViewType}
                hideGroups={hideGroups}
            />
            <div className="dual-select__controls">
                {showAssignAll &&
                <div
                    className="dual-select__control-item"
                    onClick={moveAllRight}
                >
                    <i className="fa fa-chevron-right"/>
                    <i className="fa fa-chevron-right"/>
                </div>
                }
                <div
                    className="dual-select__control-item"
                    onClick={moveRight}
                >
                    <i className="fa fa-chevron-right"/>
                </div>
                <div
                    className="dual-select__control-item"
                    onClick={moveLeft}
                >
                    <i className="fa fa-chevron-left"/>
                </div>
                {showAssignAll &&
                <div
                    className="dual-select__control-item"
                    onClick={moveAllLeft}
                >
                    <i className="fa fa-chevron-left"/>
                    <i className="fa fa-chevron-left"/>
                </div>
                }
            </div>
            <DualSelectBoxContainer
                source="assigned"
                list={filteredAssignedItems}
                selected={selectedAssignedItems}
                handleItemSelect={handleItemSelect}
                handleSearchFilter={handleSearchFilter}
                handleClearSearch={handleClearSearch}
                handleSortDirection={setAssignedSortDirection}
                sortDirection={assignedSortDirection}
                searchValue={assignedSearchValue}
                contentType={contentType}
            />
        </div>
    );
};

export default DualSelect;